import { e$2, t$2, a$1, n$2, r$1, u$1, i$1, l } from '@/js/global/global';
import { Delegate } from '@/js/modules/Delegate'
import { shouldAnimate } from '@/js/global/helpers'
import { animateMeganav } from '@/js/global/animations'

function Navigation(node, headerSection) {
  if (!node) return;
  const dropdownTriggers = t$2("[data-dropdown-trigger]", node);
  const meganavTriggers = t$2("[data-meganav-trigger]", node);
  const meganavs = t$2(".meganav, node");
  const nonTriggers = t$2(".header__links-list > li > [data-link]:not([data-meganav-trigger]):not([data-dropdown-trigger])", node);
  const header = n$2('[data-section-type="header"]', document.body);
  const primaryRow = n$2(".header__links-primary", header);
  const submenuItem = n$2(".navigation__submenu .navigation__submenu-item", node);
  if (!dropdownTriggers) return;

  // Set submenu item height for submenu depth 2 offset
  if (submenuItem) {
    node.style.setProperty("--submenu-item-height", "".concat(submenuItem.clientHeight, "px"));
  }
  const delegate = new Delegate(document.body);
  delegate.on("click", null, e => handleClick(e));
  delegate.on("mouseover", ".header-overlay__inner", () => {
    if (Shopify.designMode && headerSection.meganavOpenedFromDesignMode) {
      // Closing on shade overlay is too finicky when opened via block
      return;
    }
    closeAll(node);
  });
  meganavs.forEach(nav => {
    if (shouldAnimate(nav)) {
      animateMeganav(nav);
    }
  });
  const events = [e$2(dropdownTriggers, "focus", e => {
    e.preventDefault();
    toggleMenu(e.currentTarget.parentNode);
  }), e$2(dropdownTriggers, "mouseover", e => {
    e.preventDefault();
    toggleMenu(e.currentTarget.parentNode, true);
  }), e$2(meganavTriggers, "focus", e => {
    e.preventDefault();
    showMeganav(e.target, e.target.dataset.meganavHandle);
  }), e$2(meganavTriggers, "mouseover", e => {
    e.preventDefault();
    showMeganav(e.target, e.target.dataset.meganavHandle);
  }), e$2(nonTriggers, "mouseover", () => {
    closeAll();
  }), e$2(primaryRow, "mouseout", e => {
    var _e$relatedTarget;
    let isMousingOutOfPrimaryRow = ((_e$relatedTarget = e.relatedTarget) === null || _e$relatedTarget === void 0 ? void 0 : _e$relatedTarget.closest(".header__links-primary")) != primaryRow;
    if (isMousingOutOfPrimaryRow) {
      closeAll();
    }
  }), e$2(headerSection.container, "mouseleave", () => {
    i$1(header, "animation--dropdowns-have-animated-once");
    i$1(header, "animation--dropdowns-have-animated-more-than-once");
  }), e$2(node, "keydown", _ref => {
    let {
      keyCode
    } = _ref;
    if (keyCode === 27) closeAll();
  }), e$2(t$2(".header__links-list > li > a", node), "focus", () => {
    if (!userIsUsingKeyboard()) return;
    closeAll();
  }), e$2(t$2("[data-link]", node), "focus", e => {
    e.preventDefault();
    if (!userIsUsingKeyboard()) return;
    const link = e.currentTarget;
    if (link.hasAttribute("data-dropdown-trigger")) {
      toggleMenu(link.parentNode);
    }
    const siblings = t$2("[data-link]", link.parentNode.parentNode);
    siblings.forEach(el => l(t$2("[data-submenu]", el.parentNode), "active", el === link));
  }),
  // Close everything when focus leaves the main menu and NOT into a meganav
  e$2(t$2("[data-link]", node), "focusout", e => {
    if (!userIsUsingKeyboard()) return;
    if (e.relatedTarget && !(e.relatedTarget.hasAttribute("data-link") || e.relatedTarget.closest(".meganav"))) {
      closeAll();
    }
  }),
  // Listen to horizontal scroll to offset inner menus
  e$2(node, "scroll", () => {
    document.documentElement.style.setProperty("--navigation-menu-offet", "".concat(node.scrollLeft, "px"));
  })];
  function userIsUsingKeyboard() {
    return a$1(document.body, "user-is-tabbing");
  }
  function showMeganav(menuTrigger, handle) {
    const menu = n$2(".meganav[data-menu-handle=\"".concat(handle, "\"]"), header);
    if (!menu || a$1(menu, "active")) return;
    closeAll(undefined, {
      avoidShadeHide: true
    });
    menuTrigger.setAttribute("aria-expanded", true);
    if (menu.dataset.alignToTrigger) {
      alignMenuToTrigger(menu, menuTrigger);
    }
    menu.setAttribute("aria-hidden", false);
    u$1(header, "dropdown-active");
    u$1(menu, "active");
    r$1("headerOverlay:show");
  }
  function alignMenuToTrigger(menu, menuTrigger) {
    const headerInner = n$2(".header__inner", headerSection.container);
    const menuTriggerLeftEdge = menuTrigger !== null && menuTrigger !== void 0 && menuTrigger.getBoundingClientRect ? menuTrigger.getBoundingClientRect().left : menuTrigger.offsetLeft;
    const menuWidth = menu.getBoundingClientRect ? menu.getBoundingClientRect().width : menu.offsetWidth;
    const headerWidth = headerInner.getBoundingClientRect ? headerInner.getBoundingClientRect().width : headerInner.offsetWidth;
    const viewportWidth = window.innerWidth;
    let menuLeftAlignment = menuTriggerLeftEdge;
    if (menu.dataset.meganavType) {
      menuLeftAlignment -= 24;
    }
    const outerMargins = viewportWidth - headerWidth;
    const menuLeftOffset = menuWidth === viewportWidth ? 0 : outerMargins / 2;

    // menu width exceeds available width from trigger point
    if (menuLeftAlignment - menuLeftOffset + menuWidth > headerWidth) {
      const offset = viewportWidth - menuWidth;
      if (offset < outerMargins) {
        // center menu if width exceeds but would push passed the left edge.
        const menuCenterOffset = offset / 2;
        menuLeftAlignment = offset - menuCenterOffset;
      } else {
        // menu will align offset left without pushing to the right edge
        menuLeftAlignment = offset - menuLeftOffset;
      }
    }
    menu.style.left = "".concat(menuLeftAlignment, "px");
    u$1(menu, "customAlignment");
  }
  function alignSubmenu(menu, parentSubmenu) {
    var _parentSubmenu$getBou;
    const viewportWidth = window.innerWidth;
    const parentSubmenuRightPosition = parentSubmenu === null || parentSubmenu === void 0 ? void 0 : (_parentSubmenu$getBou = parentSubmenu.getBoundingClientRect()) === null || _parentSubmenu$getBou === void 0 ? void 0 : _parentSubmenu$getBou.right;
    const availableSpace = viewportWidth - parentSubmenuRightPosition - 24;
    const menuWidth = menu.offsetWidth;
    availableSpace < menuWidth ? menu.dataset.position = "left" : menu.dataset.position = "right";
  }
  function toggleMenu(el, force) {
    const menu = n$2("[data-submenu]", el);
    const menuTrigger = n$2("[data-link]", el);
    const parentSubmenu = el.closest("[data-submenu]");
    let action;
    if (force) {
      action = "open";
    } else if (force !== undefined) {
      action = "close";
    }
    if (!action) {
      action = a$1(menu, "active") ? "close" : "open";
    }
    if (action === "open") {
      // Make sure all lvl 2 submenus are closed before opening another
      if ((parentSubmenu === null || parentSubmenu === void 0 ? void 0 : parentSubmenu.dataset.depth) === "1") {
        closeAll(parentSubmenu, {
          avoidShadeHide: true
        });
      } else {
        closeAll(undefined, {
          avoidShadeHide: true
        });
      }
      showMenu(el, menuTrigger, menu);
    }
    if (action == "close") {
      hideMenu(el, menuTrigger, menu);
    }
  }
  function showMenu(el, menuTrigger, menu) {
    menuTrigger.setAttribute("aria-expanded", true);
    menu.setAttribute("aria-hidden", false);
    const depth = parseInt(menu.dataset.depth, 10);
    const childSubmenu = t$2('[data-depth="2"]', el);
    if (depth === 1) {
      alignMenuToTrigger(menu, menuTrigger);
    }
    if (depth === 1 && childSubmenu.length) {
      childSubmenu.forEach(sub => alignSubmenu(sub, menu));
    }
    u$1(menu, "active");
    u$1(header, "dropdown-active");
    r$1("headerOverlay:show");
  }
  function hideMenu(el, menuTrigger, menu) {
    // If the toggle is closing the element from the parent close all internal
    if (a$1(el.parentNode, "header__links-list")) {
      closeAll();
      return;
    }
    menuTrigger.setAttribute("aria-expanded", false);
    menu.setAttribute("aria-hidden", true);
    i$1(menu, "active");
  }

  // We want to close the menu when anything is clicked that isn't a submenu
  function handleClick(e) {
    if (!e.target.closest("[data-submenu-parent]") && !e.target.closest(".meganav") && !e.target.closest("[data-search]") && !e.target.closest("[data-quick-search]")) {
      closeAll();
    }
  }
  function closeAll() {
    let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : node;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const subMenus = t$2("[data-submenu]", target);
    const parentTriggers = t$2("[data-parent], [data-link]", target);
    i$1(subMenus, "active");
    subMenus.forEach(sub => sub.setAttribute("aria-hidden", true));
    parentTriggers.forEach(trig => trig.setAttribute("aria-expanded", false));
    i$1(header, "dropdown-active");
    if (!options.avoidShadeHide) {
      r$1("headerOverlay:hide");
    }
  }
  function destroy() {
    delegate.off();
    events.forEach(evt => evt());
  }
  return {
    destroy
  };
}

export { Navigation }